import {Component, Input, ViewChild} from "@angular/core";
import {AbstractControl, FormControl, FormGroup, Validators} from "@angular/forms";
import {Store} from "@ngrx/store";
import {I18nDictionaryComponent} from "src/app/shared/components/i18n-dictionary/i18n-dictionary.component";
import {request} from "../../actions/quote.action";
import {Country} from "../../model/country";
import {QuoteConstants} from "../../model/quote";
import * as fromQuote from '../../reducers'
import * as QuoteActions from '../../actions/quote.action';
import { User } from "src/app/user/models/user";


@Component({
    selector: 'request-quote',
    templateUrl: './request-quote.component.html',
    styleUrls: ['./request-quote.component.scss']
})

export class ReuqestQuoteComponent{
    readonly fieldFirstNameTextId = 'field-first-name';
    readonly fieldLastNameTextId = 'field-last-name';
    readonly fieldCompanyTextId = 'request-quote-form_field-company';
    readonly fieldStreetTextId = 'request-quote-form_field-street';
    readonly fieldCountryTextId = 'request-quote-form_field-country';
    readonly fieldZipTextId = 'request-quote-form_field-first-zip';
    readonly fieldCityTextId = 'request-quote-form_field-first-city';
    readonly fieldVatInTextId = 'request-quote-form_field-first-vat-in';

    @ViewChild(I18nDictionaryComponent, { static: true })
    i18nDictionary: I18nDictionaryComponent;


    constructor(private store: Store<fromQuote.State>) {}

    @Input() isOrder;

    @Input() countriesIsPending;

    @Input() quote;

    _countries: Country[];

    @Input()
    set countries(countries: Country[]) {
        this._countries = countries
            .filter(c => c.name != null)
            .sort((c1, c2) => c1.name > c2.name ? 1 : -1);

        this.countryIdControl.reset('');
    }

    @Input()
    set user(user: User) {
        console.log(user)
        this.firstNameControl.setValue(user.firstname);
        this.lastNameControl.setValue(user.lastname);
        this.vatControl.setValue(user?.taxvat);

        const defaultAddress = user.addresses?.filter((adr) => adr.default_shipping)[0];

        this.companyControl.setValue(defaultAddress?.company);
        this.streetControl.setValue(defaultAddress?.street[0]);
        this.countryIdControl.setValue(defaultAddress?.country_id);
        this.zipCodeControl.setValue(defaultAddress?.postcode);
        this.cityControl.setValue(defaultAddress?.city);
    }


    readonly firstNameMaxLength = QuoteConstants.ADDRESS_FIRST_NAME_MAX_LENGTH;
    readonly lastNameMaxLength = QuoteConstants.ADDRESS_LAST_NAME_MAX_LENGTH;
    readonly companyMaxLength = QuoteConstants.ADDRESS_COMPANY_MAX_LENGTH;
    readonly zipCodeMaxLength = QuoteConstants.ADDRESS_ZIP_CODE_MAX_LENGTH;
    readonly cityMaxLength = QuoteConstants.ADDRESS_CITY_MAX_LENGTH;
    readonly vatMaxLength = QuoteConstants.ADDRESS_VAT_MAX_LENGTH;

    form = new FormGroup({
        firstName: new FormControl('', [
            Validators.required,
            Validators.maxLength(this.firstNameMaxLength)
        ]),
        lastName: new FormControl('', [
            Validators.required,
            Validators.maxLength(this.lastNameMaxLength)
        ]),
        company: new FormControl('', [
            Validators.required,
            Validators.maxLength(this.companyMaxLength)
        ]),
        street: new FormControl('', [
            Validators.required
            // street doesn't have a max length
        ]),
        countryId: new FormControl('', [
            Validators.required
        ]),
        zipCode: new FormControl('', [
            Validators.required,
            Validators.maxLength(this.zipCodeMaxLength)
        ]),
        city: new FormControl('', [
            Validators.required,
            Validators.maxLength(this.cityMaxLength)
        ]),
        vat: new FormControl('', [
            Validators.required,
            Validators.maxLength(this.vatMaxLength)
        ])
    });

    get firstNameControl(): AbstractControl {
        return this.form.get('firstName');
    }

    get lastNameControl(): AbstractControl {
        return this.form.get('lastName');
    }

    get companyControl(): AbstractControl {
        return this.form.get('company');
    }

    get streetControl(): AbstractControl {
        return this.form.get('street');
    }

    get countryIdControl(): AbstractControl {
        return this.form.get('countryId');
    }

    get zipCodeControl(): AbstractControl {
        return this.form.get('zipCode');
    }

    get cityControl(): AbstractControl {
        return this.form.get('city');
    }

    get vatControl(): AbstractControl {
        return this.form.get('vat');
    }

    onRequestQuote() {
        if(this.form.valid) {
            const command = {
                address: {...this.form.value},
                quote: this.quote,
                isOrder: this.isOrder
            }
            this.store.dispatch(request({command: command}));
            this.store.dispatch(QuoteActions.closeAllSideNavs());
            this.store.dispatch(QuoteActions.openQuoteOrderComplete());
        }
    }

    closeRequestQuote() {
        this.store.dispatch(QuoteActions.closeRequestQuote());
    }
}


